import styled from "styled-components";

export const UserDataWrapper = styled.div`
  display: flex;
  gap: 8.4rem;
  width: 100%;
  .data-item {
    display: flex;
    flex-direction: column;
    min-width: 25%
    max-width: 25%;
    gap: 1rem;
    .label {
      font-size: 1.2rem;
      font-weight: 400;
      color: var(--USER-DETAIL-LABEL);
    }
    .item {
      font-size: 1.6rem;
      font-weight: 400;
      color: var(--PRIMARY);
    }
  }
`;
